import { runningInRNWebView, postMessageRN, WebToRNAction } from '@eika-infrastruktur/mobilbank-lib';

export default async (textToCopy?: string) => {
    if (!textToCopy) return;
    if (runningInRNWebView) {
        postMessageRN({
            action: WebToRNAction.COPY_TEXT,
            payload: textToCopy,
        });
    } else {
        try {
            await navigator.clipboard.writeText(textToCopy);
        } catch (_) {
            const type = 'text/plain';
            const blob = new Blob([textToCopy], { type });
            const data = [new ClipboardItem({ [type]: blob })];
            await navigator.clipboard.write(data);
        }
    }
};
